export enum InvoiceType {
  SALES = 'SALES',
  SALES_CASH_RECEIPT = 'SALES_CASH_RECEIPT',
  SALES_EU_GOODS = 'SALES_EU_GOODS',
  SALES_EU_SERVICES = 'SALES_EU_SERVICES',
  SALES_HOUSEHOLD_FI = 'SALES_HOUSEHOLD_FI',
  SALES_HOUSEHOLD_SE_ROT = 'SALES_HOUSEHOLD_SE_ROT',
  SALES_HOUSEHOLD_SE_RUT = 'SALES_HOUSEHOLD_SE_RUT',
  SALES_NONEU_GOODS = 'SALES_NONEU_GOODS',
  SALES_NONEU_SERVICES = 'SALES_NONEU_SERVICES',
  SALES_OFFER = 'SALES_OFFER',
  SALES_REVERSE_VAT = 'SALES_REVERSE_VAT',
  SALES_VATLESS = 'SALES_VATLESS',
  SALES_VATNOTLIABLE = 'SALES_VATNOLIABLE',
}
